module.exports = __webpack_public_path__ + "img/mir-pay.d6c92c7b.svg";